import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Loader, Icon } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import Table from '../../../../Components/Table';
import { __, formatPrice } from '../../../../Utils';
import QuantityPicker from '../../../../Components/QuantityPicker';

const MainWrapper = styled.div``;
const StyledHeader = styled.div`
  display: flex;
  margin-left: 4px;
  font-size: 12px;
  color: #434245;
  margin-top: 15px;
`;

const StyledTd = styled.div`
  display: flex;
  margin-left: 10px;
  margin-top: 8px;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 12px;
  color: #434245;
`;

const AddToCardWrapper = styled.div`
  height: ${rem(32)};
  width: ${rem(32)};
  border: 1px solid #70af00;
  border-radius: ${rem(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  cursor: pointer;
`;

// const NumberInCart = styled.div`
//   height: ${rem(32)};
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

const Pcs = styled.div`
  min-width: ${rem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;

const QuantityAddWrapper = styled.div`
  display: flex;
  align-items: center;
`;

class CatalogProductVariants extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 0,
      defaultQuantity: props.quantity,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.quantity !== nextProps.quantity) {
      this.setState({
        quantity: 0,
        defaultQuantity: nextProps.quantity,
      });
    }
  }

  createComplementarsProductsColumns() {
    const { loading } = this.props;

    return [
      {
        accessor: '_id',
        Header: () => <StyledHeader>{__('Číslo')}</StyledHeader>,
        maxWidth: 110,
        Cell: props => {
          return <StyledTd>{props.value}</StyledTd>;
        },
      },

      {
        accessor: 'ean',
        Header: () => <StyledHeader>{__('Ean')}</StyledHeader>,
        maxWidth: 120,
        Cell: props => {
          return <StyledTd>{props.value}</StyledTd>;
        },
      },

      {
        accessor: 'description',
        Header: () => <StyledHeader>{__('Názov')}</StyledHeader>,
        minWidth: 130,
        Cell: props => {
          return <StyledTd>{props.value}</StyledTd>;
        },
      },

      {
        accessor: 'unit_volume',
        Header: () => <StyledHeader>{__('Objem')}</StyledHeader>,
        width: 65,
        Cell: props => {
          return <StyledTd>{props.value ? props.value : 'N/A'}</StyledTd>;
        },
      },
      {
        accessor: 'price',
        Header: () => (
          <StyledHeader>{__('Doporučená cena bez DPH')}</StyledHeader>
        ),
        minWidth: 80,
        Cell: props => {
          return <StyledTd>{formatPrice(props.value)}</StyledTd>;
        },
      },

      {
        accessor: '_id',
        minWidth: 55,
        Header: () => <StyledHeader>{__('Počet kusov')}</StyledHeader>,
        Cell: props => {
          return (
            <QuantityAddWrapper>
              <QuantityPicker
                value={
                  this.state.quantity ||
                  this.state.defaultQuantity * props.original.count
                }
                changeValue={e => this.handleChange(e)}
              />
              <Pcs />

              <AddToCardWrapper
                onClick={() =>
                  this.props.addComProductToCard(
                    props.value,
                    this.state.quantity ||
                      this.state.defaultQuantity * props.original.count,
                  )
                }
              >
                {loading ? (
                  <Loader />
                ) : (
                  <Icon name="cart_add" color="#70af00" />
                )}
              </AddToCardWrapper>
            </QuantityAddWrapper>
          );
        },
      },
    ];
  }

  handleChange(e) {
    this.setState({
      quantity: e,
    });
  }

  render() {
    const { data, onVariantSelect } = this.props;

    return (
      <MainWrapper>
        <Table
          columns={this.createComplementarsProductsColumns()}
          minWidth={10}
          loadingColor="#70af00"
          data={data}
          style={{
            border: 'unset',
          }}
          pieces={this.state.pieces}
          pageSize={data.length}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: () => onVariantSelect(rowInfo.index),
                style: {
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
          getTdProps={() => {
            return { style: { padding: 0, margin: 'auto', border: 0 } };
          }}
          getTheadThProps={(state, rowInfo, column) => {
            return {
              style: { border: 0 },
            };
          }}
          className="-highlight -striped"
          offset={120}
        />
      </MainWrapper>
    );
  }
}

CatalogProductVariants.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      ean: PropTypes.string,
      name: PropTypes.string,
      volume: PropTypes.string,
      on_stock: PropTypes.number,
      price: PropTypes.shape({}),
    }),
  ),
  onVariantSelect: PropTypes.func,
  loading: PropTypes.bool,
  addComProductToCard: PropTypes.func,
  quantity: PropTypes.number,
};

CatalogProductVariants.defaultProps = {
  data: [],
  onVariantSelect: () => {},
  addComProductToCard: () => {},
  loading: false,
  quantity: 1,
};

export default CatalogProductVariants;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/Complementars /index.jsx